import { ArrowRight, Check } from "lucide-react";

export function ServiceCard({ service, onChoose }) {
  return (
    <article
      data-testid={service.testid}
      className="group h-full bg-white border border-ink/8 rounded-[2rem] overflow-hidden flex flex-col hover:shadow-[0_24px_60px_rgba(28,25,23,0.08)] transition-shadow duration-500"
    >
      {service.img && (
        <div className={`overflow-hidden ${service.imgAspectClass || "h-80 sm:h-96"}`}>
          <img
            src={service.img}
            alt={service.title}
            loading="lazy"
            className={`h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 ${service.imgObjectClass || ""}`}
          />
        </div>
      )}
      <div className="p-7 sm:p-10 flex flex-col flex-1">
        <span className="text-[10px] font-mono uppercase tracking-[0.24em] text-gold">{service.tag}</span>
        <h3 className="mt-3 font-serif text-2xl sm:text-3xl text-ink">{service.title}</h3>
        <p className="mt-3 text-sm leading-relaxed text-stone-600">{service.copy}</p>
        <ul className="mt-6 space-y-2.5 flex-1">
          {service.points.map((p) => (
            <li key={p} className="flex items-start gap-2.5 text-sm text-stone-700">
              <Check size={15} className="mt-0.5 shrink-0 text-gold" />
              {p}
            </li>
          ))}
        </ul>
        <button
          data-testid={`${service.testid}-cta`}
          onClick={() => onChoose(service.id)}
          className="mt-8 self-start group/btn inline-flex items-center gap-2 rounded-full border border-ink/15 px-6 py-3 text-sm font-medium text-ink hover:border-gold hover:text-gold transition-colors duration-300"
        >
          {service.cta}
          <ArrowRight size={15} className="transition-transform duration-300 group-hover/btn:translate-x-1" />
        </button>
      </div>
    </article>
  );
}
